import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=86c1cd02&scoped=true&"
import script from "./AgeVerification.vue?vue&type=script&lang=ts&"
export * from "./AgeVerification.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=86c1cd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c1cd02",
  null
  
)

export default component.exports